import SelectDateRange from '../../../../../../components/SelectDateRange/SelectDateRange';
import RoomGuestSelector from '../../../../../../components/roomGuestSelector/RoomGuestSelector';
import { VehicleSelector } from '../../../../../../components/vehicleSelector/VehicleSelector';
import Tooltip from '../../../../../../components/tooltip/Tooltip';
import { ReactComponent as InfoI } from '../../../../../../assets/icons/trvto_info.svg';
import '../../tripBookingTab.css';
import handlestartCity from '../handleBaseCity';
import Dropdown from '../../../../../../components/dropdown/Dropdown';

export const CustomTripBookingTab = ({
    booking,
    setBooking,
    confirmedBookingData,
    vehicleCounts,
    setVehicleCounts,
    customBooking,
    setCustomBooking,
    vehicleTypes,
    packData,
    optionsForMeetUpLocation,
    startCity,
    setIndex
}) => {
    const isGroupOptions = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
    ];
    const vehicle = customBooking?.customTrip?.vehicleType?.filter((item) => item.vehicleCount > 0);
    return (
        <div className=''>
            <div>
                <label className='tripBookDatalabelFirst'>Select Date</label>
                <SelectDateRange
                    startDate={customBooking.startDate}
                    endDate={customBooking.endDate}
                    packData={packData}
                    setDates={(start, end) =>
                        setCustomBooking((prev) => ({
                            ...prev,
                            startDate: start || null,
                            endDate: end || null
                        }))
                    }
                    daysToAdd={packData?.days}
                    confirmedBookingData={confirmedBookingData}
                />
            </div>
            <div className='dropdownDiv'>
                <div className='dropdownLabelText'>
                    <label className='dropdownlabel'>Start City</label>
                    <Tooltip content='Select the city from which your trip will be initiated' position='top'>
                        <span className='eyeIcon'>
                            <InfoI color='blue' width={15} height={15} />
                        </span>
                    </Tooltip>
                </div>
                <select
                    value={customBooking.startCity}
                    name='startCity'
                    onChange={(e) => handlestartCity(e, setCustomBooking, startCity.current, setIndex)}
                    required={true}
                    className='dropdownSelect'
                    disabled={confirmedBookingData?.startCity}
                >
                    <option value='-1'>Select</option>
                    {startCity.current.map(function (val, typeIndex) {
                        return (
                            <option key={typeIndex} value={val}>
                                {val}
                            </option>
                        );
                    })}
                </select>
            </div>
            <Dropdown
                label='Pickup Location'
                name='pickupLocation'
                options={optionsForMeetUpLocation}
                value={customBooking?.pickupLocation || customBooking?.pickupLocation}
                req={true}
                setFormData={setCustomBooking}
                disabled={
                    !customBooking?.startCity ||
                    (!confirmedBookingData?.isTripMoreThanOneDays &&
                        (confirmedBookingData?.pickupLocation || confirmedBookingData?.meetupPoint))
                }
                infoIcon={true}
                infoContent={'Select the point from which your trip will be initiated'}
            />
            <div>
                <div className='dropdownLabelText'>
                    <label className='dropdownlabel'>Select Rooms & Guest</label>
                    <Tooltip content='Two sharing rooms. Each room can be shared by two people.' position='top'>
                        <span className='eyeIcon'>
                            <InfoI color='blue' width={15} height={15} />
                        </span>
                    </Tooltip>
                </div>
                <RoomGuestSelector
                    rooms={customBooking?.customTrip?.rooms}
                    setRooms={(updatedRooms) =>
                        setCustomBooking((prev) => ({
                            ...prev,
                            customTrip: {
                                ...prev.customTrip,
                                rooms: updatedRooms
                            }
                        }))
                    }
                />
            </div>
            {packData?.price[0]?.customPrice?.groupPrice > 0 && (
                <>
                    <div className='dropdownLabelText'>
                        <label className='dropdownlabel'>Select Group</label>
                        <Tooltip
                            content='Select No if you prefer a private vehicle.
Select Yes to share with a group on the same itinerary and save cost'
                            position='top'
                        >
                            <span className='eyeIcon'>
                                <InfoI color='blue' width={15} height={15} />
                            </span>
                        </Tooltip>
                    </div>
                    <select
                        value={customBooking?.customTrip?.isGroup}
                        name='isGroup'
                        onChange={(e) => {
                            const isTrue = e.target.value === 'true';

                            if (isTrue) {
                                setCustomBooking((prev) => ({
                                    ...prev,
                                    customTrip: {
                                        ...prev.customTrip,
                                        vehicleType: [
                                            { vehicleName: 'Two Wheeler', vehicleCount: 0 },
                                            { vehicleName: 'Two Wheeler - Premium', vehicleCount: 0 },
                                            { vehicleName: 'Car - 5 Seater', vehicleCount: 0 },
                                            { vehicleName: 'Car - 7 Seater', vehicleCount: 0 }
                                        ]
                                    }
                                }));
                            }

                            setCustomBooking((prev) => ({
                                ...prev,
                                customTrip: { ...prev.customTrip, isGroup: isTrue }
                            }));
                        }}
                        required={true}
                        className='dropRegSelect'
                        disabled={confirmedBookingData?.pickupLocation}
                    >
                        <option value='-1'>Select</option>
                        {isGroupOptions.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={String(val.value)}>
                                    {val.label}
                                </option>
                            );
                        })}
                    </select>{' '}
                </>
            )}
            {customBooking?.customTrip?.isGroup === false && (
                <>
                    <div className='dropdownLabelText'>
                        <label className='dropdownlabel'>Select Vehicle</label>
                        <Tooltip content='Select a vehicle for your trip based on your requirements' position='top'>
                            <span className='eyeIcon'>
                                <InfoI color='blue' width={15} height={15} />
                            </span>
                        </Tooltip>
                    </div>
                    <VehicleSelector
                        label={vehicle?.length > 0 ? `Vehicles(${vehicle?.length})` : 'Select Vehicle'}
                        options={vehicleTypes}
                        setCustomBooking={setCustomBooking}
                        vehicleCounts={vehicleCounts}
                        setVehicleCounts={setVehicleCounts}
                    />{' '}
                </>
            )}
        </div>
    );
};
